import { seoDictionary } from '@funtech-int/yango-shared';
import { IntlShape } from 'react-intl';

export const dictionary = {
    ...seoDictionary,
    home_seo_title: (intl: IntlShape, { brandName }: { brandName: string }) =>
        intl.formatMessage(
            {
                id: 'allplay.home_seo_title',
                defaultMessage: 'Watch Movies and Series | {brandName}',
                description: 'Home page seo title',
            },
            { brandName }
        ),
    home_seo_description: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'allplay.home_seo_description',
            defaultMessage: 'Stream movies and series on phones, tablets and TV.',
            description: 'Home page meta description',
        }),
    personal_collection_meta_description: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'allplay.personal_collection_meta_description',
            defaultMessage: 'Watch later list with movies and series',
            description: 'Personal collection page meta description',
        }),
};
